// PDFCanvasViewer.js
import React from "react";
import { useDispatch } from "react-redux";
import { setInvoiceListTab } from "../../../feature/authSlice";

const PdfView = ({ fileUrl }) => {
  const pdfFile = localStorage.getItem("FilePath");
  const  dispatch = useDispatch()

  return (
    <div>
        <button
                      className="btn btn-primary mb-4"
                      style={{ minWidth: "150px" }}
                      onClick={() => {
dispatch(setInvoiceListTab(6))
                    window.history.back() 
                    
                    }}
                    >
                      Go Back
                    </button>
      <iframe src={pdfFile} width="100%" height={"650px"}></iframe>
    </div>
  );
};

export default PdfView;
